/* global $ */

const $toggler = $('.js-read-more');
const $content = $('.js-read-more-content');

const readMore = {
  initialize() {
    $content.on('shown.bs.collapse', () => {
      $toggler.text($toggler.data('expanded-text'));
    });

    $content.on('hidden.bs.collapse', () => {
      $toggler.text($toggler.data('collapsed-text'));
    });
  },
};

export default readMore;
